// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 2H2V15H7.5V13H4V4H13V7.5H15V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 9H9V22H22V9ZM13.5002 14.0859L15.0002 15.5859L18.0002 12.5859L19.4144 14.0002L15.0002 18.4144L12.0859 15.5002L13.5002 14.0859Z"}}]};

const ComponentCheckboxFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-checkbox-filled',
    ref,
    icon: element,
  },
));

ComponentCheckboxFilledIcon.displayName = 'ComponentCheckboxFilledIcon';

export default ComponentCheckboxFilledIcon;
